const colors = {
  primary: "#8032A1",
  primaryRGB: "137,50,161",
  secundary: "#53B9C7",
  secundaryRGB: "83, 185, 199",
  boldGray: "#434343",
  mediumGray: "#808080",
  btnDisabledPrimary: "#c1c1c1",
  btnDisabledPrimaryRGB: "193, 193, 193",
  buttonBorder: "#EFEFEF",
  buttonBorderRGB: "239, 239, 239",
  mainBg: "#FBFBFB",
  orange: "#f39d3e",
  orangeRGB: "243, 157, 62",
  borderConfirmed: "#87B634",
  borderConfirmedRGB: "135, 182, 52",
  errorRed: "#d74242",
  errorRedRGB: "215, 66, 66",
  lithPrimary: "rgba(128, 50, 161, 0.1);",
  primaryRgba: "rgba(137,50,161, 0.1)",
  lithGrayBg: "#F6F3F8",
  lithlithGray: "#E6E6E6",
  lithlithGrayRGB: "225, 225, 225",
  mediumGrayRGB: "128, 128, 128",
  lithGreen: "#F3F8EB",
  mediumGreen: "#BCD98E",
  fontLith: "#fff",
  notification: "#FC5959",
  border: "#E0EDEF",
  borderFiltro: "#c0c0c0",
  buttonBgActive: "rgba(152,89,180, 0.1)",
  bgPending: "rgba(215,66,66, 0.1)",
  borderPending: "#D74C4C",
  borderPendingRGB: "215, 76, 76",
  bgConfirmed: "rgba(135,182,52, 0.1)",
  bgForeseen: "rgba(83,185,199, 0.1)",
  bgConcluded: "rgba(182, 182, 182, 0.1)",
  bgConcludedRGB: "182, 182, 182",
  inputModal: "#f4f4f4",
  modalBg: "#fafafa",
  lithRed: "#FBEDED",
  transparentGreen: "rgb(109,210,48,.1)",
  btnHoverPrimary: "#F2EAF6",
  theadBg: "128, 50, 161",
  borderCard: "#E8ECEF",
  darkGreen: "#6C922A",
  pdfRGB: "254,77,151",
  wordRGB: "77,124,254",
  excellRGB: "106,206,65",
  imgRGB: "255,171,43",
};

export default colors;
